import classNames from "classnames";
import { replaceVariable } from "../../utils/string";
import { DComponent } from "../DComponent";
import { LocalStorage } from "../../models/LocalStorage";

export default class RadioButton extends DComponent {
  constructor({
    parent,
    id,
    data = [],
    label = "",
    labelText = "",
    selectedValue = "",
    isRequired = false,
    disabled = false,
    onChange = () => { },
    inline = false,
    optionInline = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("RadioButton", {
        "is-required": isRequired,
        "disabled": disabled,
        "hide-label": !labelText && !label,
        "inline": inline,
        "option-inline": optionInline,
      }),
      label: label,
      labelText: labelText,
    });
    this.selectedValue = selectedValue;
    this.data = data;
    this.onChange = onChange;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "RadioButton");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.data.length) {
      this.data.forEach(element => {
        $(".list-option", this.element).append(replaceVariable(require("html-loader!./item.html"), {
          value: element.value,
          labelI18n: element.i18n || "",
          label: element.i18n ? $.i18n(element.i18n) : (LocalStorage.getLanguage() === "vi" && element.label_vi ? element.label_vi : element.label),
          class: element.value === this.selectedValue ? " active" : ""
        })
        )
      });
      $(".radio", this.element).on("click", (e) => {
        let value = $(e.currentTarget).attr("data-id");
        if (this.selectedValue !== value) {
          this.setValue(value);
          typeof this.onChange == "function" && this.onChange(value);
        }
      })
    }
  }

  getValue() {
    let radio = $(".radio.active", this.element);
    if (!radio.length) return "";
    return radio.attr("data-id");
  }

  setValue(value = "") {
    this.selectedValue = value;
    $(`.radio`, this.element).removeClass("active");
    value && $(`.radio[data-id=${value}]`, this.element).addClass("active");
  }
}